import { render, staticRenderFns } from "./Reply.vue?vue&type=template&id=1c8760d4&scoped=true"
import script from "./Reply.vue?vue&type=script&lang=js"
export * from "./Reply.vue?vue&type=script&lang=js"
import style0 from "./Reply.vue?vue&type=style&index=0&id=1c8760d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8760d4",
  null
  
)

export default component.exports